import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';


const AddOnProductsScreen = ({ payload, items, series,proceed,addOnPro,erp,editMode }) => {
  
  const [selectedAddOns, setSelectedAddOns] = useState([]);


    let addP=addOnPro
    if(addP){
        addP=JSON.parse(addOnPro).map((ele)=>{return {name:ele,or:0}})}
    const [confuse, setConfuse] = useState({});
    const [isChecked, setIsChecked] = useState(erp==1?true:false);
    const [prize, setPrize] = useState([]);
    const [dropMenu, setDropMenu] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        groupData(items);
    }, [items]);

    useEffect(() => {
  if (editMode && addOnPro) {
    try {
      const parsedAddOns = JSON.parse(addOnPro); // array

      // Checkbox add-ons list (same names as checkbox `name`)
      const checkboxAddOns = [
        "Digital Content",
        "Teachers Mannual",
        "T P G",
        "Teachers Dev. Video",
        "Lession Plan",
        "Telent Box",
        "FDP Online",
        "FDP Offline",
        "Holistic Report",
        "Mittlens",
        "Teachlite License",
        "Jaadui Pitara",
        "Mittstore Voucher"
      ];

      // Keep only those which belong to checkboxes
      const matchedAddOns = parsedAddOns.filter(addOn =>
        checkboxAddOns.includes(addOn)
      );

      setSelectedAddOns(matchedAddOns);
    } catch (err) {
      console.error("Invalid addOnProduct JSON", err);
    }
  }
}, [editMode, addOnPro]);


 const handleChange = (e) => {
  const { name, checked } = e.target;

  setSelectedAddOns((prev) => {
    let updated;
    if (checked) {
      updated = [...prev, name];
      console.log("Selected:", name);
    } else {
      updated = prev.filter((item) => item !== name);
      console.log("Unselected:", name);
    }
    console.log("Current Selected List:", updated);
    return updated;
  });
};

const buildAddOnCountMap = (arr) => {
  return arr.reduce((acc, item) => {
    acc[item] = (acc[item] || 0) + 1;
    return acc;
  }, {});
};

console.log(selectedAddOns,"selectedAddOns")
    const getMenu = async (pp) => {
        const body = { id: pp.map(ele => ele.menu) };
        try {
            const response = await window.Platform.database.getAddOnsMenu(body);
            if (response) {
                setDropMenu(response.data);
                setIsLoading(false);
                // if(editMode){
                //     pp.forEach((pri)=>{
                //         let a=addP.filter((ele)=>!ele.or)
                //         if(a.length){
                //             for(let i=0;i<a.length;i++){
                //                 let ap=a[i]
                //                 let ty=response.data.filter((r)=>{return r.id==pri.menu})
                //                 if(ty.filter((pr)=>pr.name==ap.name).length){
                //                     ap.or=1
                //                   pri.selected=a[0].name
                //                 }
                //             }
                               
                //         }
                //     })
                // }
                if (editMode && addOnPro) {
  const parsedAddOns = JSON.parse(addOnPro);

  const addOnCountMap = buildAddOnCountMap(parsedAddOns);

  pp.forEach((pri) => {
    const options = response.data.filter(
      (r) => r.id == pri.menu
    );

    for (let option of options) {
      if (addOnCountMap[option.name] > 0) {
        pri.selected = option.name;
        addOnCountMap[option.name]--;
        break;
      }
    }
  });
}
            }
                    
                    
                
            
        } catch (error) {
            console.error("Error fetching orders:", error);
        }
    };

    const getMenuBasedOnId = (id) => {
        return [
            { value: "", label: "Select" },
            ...dropMenu.filter(item => item.id === id || item.id.toString() === id)
                .map(item => ({ value: item.name, label: item.name }))
        ];
    };

    // const order = () => {
    //     let updatedPayload = { ...payload, addOns: prize.map(ele => ele.selected), onBoardERP: isChecked };
    //    proceed(updatedPayload)
    // };
    const order = () => {
  const prizeAddOns = prize
    .map(ele => ele.selected)
    .filter(Boolean);

  const updatedPayload = {
    ...payload,
    addOns: [...prizeAddOns, ...selectedAddOns],
    onBoardERP: isChecked
  };

  proceed(updatedPayload);
};


    const getAddONs = async (group) => {
        console.log(group)
        const a = Object.keys(group);
        const filteredSeries = series.filter(e => a.includes(e.seriesTableId));
        const addOns = filteredSeries.map(e => e.addOnProduct).filter(ele => ele !== null);
        const body = { id: addOns };

        try {
            if (addOns.length > 0) {
                const response = await window.Platform.database.getAddOns(body);
                if (response) {
                    const data = response.data;
                    let newPrize = [];
                    filteredSeries.forEach(series => {
                        data.forEach(add => {
                            if (add.product_id === series.addOnProduct) {
                                if (add.condition === "set" && group[series.seriesTableId].set.total >= add.amount) {
                                    const count = Math.floor(group[series.seriesTableId].set.total / add.amount);
                                    for (let i = 0; i < count; i++) {
                                        newPrize.push({ menu: add.name, selected: "", series: series.seriesName });
                                    }
                                } else if (
                                    group[series.seriesTableId].individual.total >= add.amount &&
                                    group[series.seriesTableId].individual.count >= add.bookCount &&
                                    (!add.maxCount || add.maxCount >= group[series.seriesTableId].individual.count)
                                ) {
                                    const count = Math.floor(group[series.seriesTableId].individual.total / add.amount);
                                    for (let i = 0; i < count; i++) {
                                        newPrize.push({ menu: add.name, selected: "", series: series.seriesName });
                                    }
                                }
                            }
                        });
                    });
                    console.log(newPrize,"EDITDATA ")
                    setPrize(newPrize);
                    if (newPrize.length > 0) {
                        getMenu(newPrize);
                    } else {
                        setIsLoading(false);
                    }
                }
            } else {
                setIsLoading(false);
            }
        } catch (error) {
            console.error("Error fetching orders:", error);
        }
    };

    const groupData = (items) => {
        
        let groupedData = {};
        items.forEach(item => {
            if (!groupedData[item.series]) {
                groupedData[item.series] = {
                    set: { total: 0.0, count: 0 },
                    individual: { total: 0.0, count: 0 }
                };
            }
            const mrp = item.price * item.qty;
            if (item.itemType?.toLowerCase() === 'choose from set') {
                groupedData[item.series].set.total += mrp;
            } else {
                groupedData[item.series].individual.total += mrp;
                groupedData[item.series].individual.count++;
            }
        });
        console.log(groupedData)
        setConfuse(groupedData);
        getAddONs(groupedData);
    };

    return (
        <div className="container">
            <h2><strong>Add-On Products</strong></h2>
            <b>Complimentary Products with Your Order</b>
            {/* <label>
                <input type="checkbox" checked={isChecked} onChange={() => setIsChecked(!isChecked)} />
                Onboard For ERP
            </label> */}
             <label className="addon-card w-25">
                        <input
                            type="checkbox"
                            name="Teachers Mannual"
                            checked={isChecked}
                            onChange={() => setIsChecked(!isChecked)}
                        />
                       <span className='ml-2'> Onboard For ERP </span> 
                    </label>
            {isLoading ? <p>Loading...</p> : (
                prize.length > 0 ? (
                    prize.map((item, index) => (
                        <div key={index} className="card">
                            <h4>Select {index + 1} Add-on Item</h4>
                            <p>Series: {item.series}</p>
                            <select
                                value={item.selected}
                                onChange={(e) => {
                                    const newPrize = [...prize];
                                    newPrize[index].selected = e.target.value;
                                    setPrize(newPrize);
                                }}
                            >
                                {getMenuBasedOnId(item.menu).map(option => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                        </div>
                    ))
                ) :<></>
                //  <b style={{ color: 'red', display:"flex", justifyContent:"center", alignItems:"center" }}>No Add-On Product</b>
            )}
            <div className='row mt-3'>
                <div className='col-md-3'>
                    <label className="addon-card w-100">
                        <input
                            type="checkbox"
                            name="Digital Content"
                            checked={selectedAddOns.includes("Digital Content")}
                            onChange={handleChange}
                        />
                        <span className='ml-2'> Digital Content </span>
                    </label>
                </div>
                <div className='col-md-3'>
                    <label className="addon-card w-100">
                        <input
                            type="checkbox"
                            name="Teachers Mannual"
                            checked={selectedAddOns.includes("Teachers Mannual")}
                            onChange={handleChange}
                        />
                       <span className='ml-2'> Teachers Mannual </span> 
                    </label>
                </div>
                <div className='col-md-3'>
                    <label className="addon-card w-100">
                        <input
                            type="checkbox"
                            name="T P G"
                            checked={selectedAddOns.includes("T P G")}
                            onChange={handleChange}
                        />
                      <span className='ml-2'> T P G </span>  
                    </label>
                </div>
                <div className='col-md-3'>
                    <label className="addon-card w-100">
                        <input
                            type="checkbox"
                            name="Teachers Dev. Video"
                            checked={selectedAddOns.includes("Teachers Dev. Video")}
                            onChange={handleChange}
                        />
                        <span className='ml-2'> Teachers Dev. Video </span>
                    </label>
                </div>
            </div>

            <div className='row mt-3'>
                <div className='col-md-3'>
                    <label className="addon-card w-100">
                        <input
                            type="checkbox"
                            name="Lession Plan"
                            checked={selectedAddOns.includes("Lession Plan")}
                            onChange={handleChange}
                        />
                        <span className='ml-2'> Lession Plan </span> 
                    </label>
                </div>
                <div className='col-md-3'>
                    <label className="addon-card w-100">
                        <input
                            type="checkbox"
                            name="Telent Box"
                            checked={selectedAddOns.includes("Telent Box")}
                            onChange={handleChange}
                        />
                        <span className='ml-2'> Telent Box </span>
                    </label>
                </div>
                <div className='col-md-3'>
                    <label className="addon-card w-100">
                        <input
                            type="checkbox"
                            name="FDP Online"
                            checked={selectedAddOns.includes("FDP Online")}
                            onChange={handleChange}
                        />
                       <span className='ml-2'> FDP Online </span> 
                    </label>
                </div>
                <div className='col-md-3'>
                    <label className="addon-card w-100">
                        <input
                            type="checkbox"
                            name="FDP Offline"
                            checked={selectedAddOns.includes("FDP Offline")}
                            onChange={handleChange}
                        />
                       <span className='ml-2'> FDP Offline</span>
                    </label>

                </div>
            </div>
             <div className='row mt-3'>
                <div className='col-md-3'>
                    <label className="addon-card w-100">
                        <input
                            type="checkbox"
                            name="Holistic Report"
                            checked={selectedAddOns.includes("Holistic Report")}
                            onChange={handleChange}
                        />
                        <span className='ml-2'> Holistic Report </span> 
                    </label>
                </div>
                <div className='col-md-3'>
                    <label className="addon-card w-100">
                        <input
                            type="checkbox"
                            name="Mittlens"
                            checked={selectedAddOns.includes("Mittlens")}
                            onChange={handleChange}
                        />
                        <span className='ml-2'> Mittlens </span>
                    </label>
                </div>
                <div className='col-md-3'>
                    <label className="addon-card w-100">
                        <input
                            type="checkbox"
                            name="Teachlite License"
                            checked={selectedAddOns.includes("Teachlite License")}
                            onChange={handleChange}
                        />
                       <span className='ml-2'> Teachlite License </span> 
                    </label>
                </div>
                <div className='col-md-3'>
                    <label className="addon-card w-100">
                        <input
                            type="checkbox"
                            name="Jaadui Pitara"
                            checked={selectedAddOns.includes("Jaadui Pitara")}
                            onChange={handleChange}
                        />
                       <span className='ml-2'> Jaadui Pitara</span>
                    </label>

                </div>
            </div>
             <div className='row mt-3'>
                <div className='col-md-3'>
                    <label className="addon-card w-100">
                        <input
                            type="checkbox"
                            name="Mittstore Voucher"
                            checked={selectedAddOns.includes("Mittstore Voucher")}
                            onChange={handleChange}
                        />
                        <span className='ml-2'> Mittstore Voucher </span> 
                    </label>
                </div>
            </div>

            <button onClick={order} className="btn btn-primary" >Proceed</button>
        </div>
    );
};

export default AddOnProductsScreen;
